import type { ExternalStudyType } from '@/api/core-api/types.gen';

/**
 * Where an admitted external participant goes: an AI-moderated study runs
 * its interview here, an unmoderated one starts from its study page.
 */
export function admittedRoute(studyType: ExternalStudyType) {
  return studyType === 'aiModerated'
    ? ('/participants/external/projects/$projectId/interview' as const)
    : ('/participants/external/projects/$projectId/study' as const);
}

/** The same choice from a project's kind of research, for pages that hold the project. */
export function admittedRouteForKind(kindOfResearch: number | undefined) {
  // 12 is AI_MODERATED_INTERVIEW; every other kind an external participant
  // can be admitted to is an unmoderated study.
  return admittedRoute(kindOfResearch === 12 ? 'aiModerated' : 'unmoderated');
}
